import React from 'react'
import autobind from 'autobind-decorator'
import persianJs from 'persianjs'
import { ListInput } from 'framework7-react';

import PureComponent from '../PureComponent'

class NumericInput extends PureComponent {
  /**
   * Notify changes to parent
   * @param {any} changedValue changed value
   */
  triggerChange(changedValue) {
    // Should provide an event to pass value to Form.
    const onChange = this.props.onChange
    if (onChange) {
      onChange(changedValue)
    }
  }

  /**
   * Normalize value
   * @param {*} value price value
   * @return {String} formatted price
   */
  normalizeValue(value) {
    if (!value) return ''

    return persianJs(value)
      .persianNumber()
      .toString()
  }

  /**
   * Handle input change
   * @param {*} e
   */
  handleInputChange(e) {
    const value = e.target.value

    const _value = this.normalizeValue(value)

    this.triggerChange(_value)
  }

  /** @inheritdoc */
  render() {
    const { ...rest } = this.props

    return <ListInput
      // {...rest}
      type="number"
      inputmode="numeric"
      pattern="[0-9]*" /* \d* */
      onChange={this.handleInputChange}
    >
      {this.props.children}
    </ListInput>
  }
}

export default autobind(NumericInput)
